import React from 'react';
import { Drawer } from 'antd';
import { X } from 'lucide-react';

/**
 * Right-side drawer for KPI drill-down. Wraps Ant Design Drawer with
 * dark-mode-aware styling and consistent header.
 */
const DataDrawer = ({ open, onClose, title, subtitle, width = 560, children, extra }) => {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      width={width}
      closable={false}
      placement="right"
      styles={{
        body: { padding: 0 },
        content: { background: 'var(--drawer-bg, hsl(var(--background)))' },
      }}
      title={
        <div className="flex items-start justify-between gap-3 -my-1">
          <div className="min-w-0">
            <h3 className="text-base font-semibold text-foreground truncate">{title}</h3>
            {subtitle && (
              <p className="text-xs text-muted-foreground mt-0.5 truncate">{subtitle}</p>
            )}
          </div>
          <div className="flex items-center gap-2">
            {extra}
            <button
              onClick={onClose}
              className="p-1.5 rounded-lg hover:bg-accent text-muted-foreground"
              aria-label="Close"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      }
      rootClassName="erp-data-drawer"
    >
      <div className="p-5 space-y-4 text-foreground">
        {children}
      </div>
    </Drawer>
  );
};

export default DataDrawer;
